import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { AdminProductDistributionPlatformListing } from 'src/api';
import Button from 'ui/atoms/button';
import Translate from 'ui/atoms/translate';
import AddInvestmentDocumentsModal from '../add-investment-documents-modal';
import Tooltip from 'src/ui/atoms/tooltip';

interface InvestmentDocumentsListProps {
  distributionPlatforms: AdminProductDistributionPlatformListing[];
  onInvestmentDocumentsAdded: () => void;
}

const AddInvestmentDocuments: FunctionComponent<InvestmentDocumentsListProps> = ({
  distributionPlatforms,
  onInvestmentDocumentsAdded,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [distributionPlatformsWithDistInfo, setDistributionPlatformsWithDistInfo] = useState<
    AdminProductDistributionPlatformListing[]
  >([]);

  const onClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const onDocumentsAdded = useCallback(() => {
    onInvestmentDocumentsAdded();
    setModalOpen(false);
  }, []);

  useEffect(() => {
    // set distribution platforms that have distribution information added
    const distributionPlatformsWithDistInfo = distributionPlatforms.filter(
      (platform) => !!platform.distributionInformation,
    );

    setDistributionPlatformsWithDistInfo(distributionPlatformsWithDistInfo);
  }, [JSON.stringify(distributionPlatforms)]);

  if (!distributionPlatforms?.length) return null;

  return (
    <>
      {distributionPlatformsWithDistInfo?.length ? (
        <Button variant="primary" icon="plus" iconColor="white" onClick={() => setModalOpen(true)}>
          <Translate name="addInvestmentDocuments.button" />
        </Button>
      ) : (
        <Tooltip content={<Translate name="addInvestmentDocuments.noDistInfoAdded" />}>
          <Button variant="primary" icon="plus" iconColor="white" disabled onClick={() => setModalOpen(true)}>
            <Translate name="addInvestmentDocuments.button" />
          </Button>
        </Tooltip>
      )}
      {isModalOpen && (
        <AddInvestmentDocumentsModal
          distributionPlatforms={distributionPlatformsWithDistInfo}
          onInvestmentDocumentsAdded={onDocumentsAdded}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default AddInvestmentDocuments;
